import PageTitle from "./include/PageTitle";
import {Helmet} from "react-helmet";
import React, {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";

const AI_model = ({title, modelData}) => {

    const location = useLocation();

    const [object, setObject] = useState(location.state?.object || modelData);

    useEffect(() => {
        if (location.state?.object) {
            setObject(location.state.object);
        }
    }, [location.state?.object]);
    return (
        <>
            <Helmet>
                <title>Zaala | AI-Model</title>
            </Helmet>
            <PageTitle title={title}/>

            <section className="service-details-page">
                <div className="container">
                    <div className="row">
                        {/* Sidebar */}
                        <div className="col-xl-4 col-lg-5">
                            <div className="service-details-sidebar-box">
                                <div className="single-sidebar-box single-sidebar__service">
                                    <div className="title-box">
                                        <h2>Model Details</h2>
                                        <div className="border-line"/>
                                    </div>
                                    <ul>
                                        <li>
                                            <strong>Type:</strong> {object.model_type}
                                        </li>
                                        <li>
                                            <strong>Version:</strong> {object.version}
                                        </li>
                                        <li>
                                            <strong>Framework:</strong> {object.framework}
                                        </li>
                                        <li>
                                            <strong>Parameters:</strong> {object.parameters}
                                        </li>
                                    </ul>
                                </div>

                                {/* Contact Box */}
                                <div className="service-details__content-text2">
                                    <h3>Use Cases</h3>
                                    <ul>
                                        {object.applications.map((application, index) => (
                                            <li key={index}>
                                                <span className="icon-checklist-2"/> {application}
                                            </li>
                                        ))}
                                    </ul>
                                </div>

                                <div className="service-details__content-text3">
                                    <h3>Performance</h3>
                                    <ul>
                                        <li>
                                            <strong>Accuracy:</strong> {object.accuracy}%
                                        </li>
                                        <li>
                                            <strong>Latency:</strong> {object.latency} ms
                                        </li>
                                        <li>
                                            <strong>Throughput:</strong> {object.throughput} inferences/sec
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        {/* Main Content */}
                        <div className="col-xl-8 col-lg-7">
                            <div className="service-details__content">
                                <h2 className="text-center mb-3">{object.name}</h2>
                                <div className="service-details__content-img1">
                                    <img
                                        src={object.thumbnail}
                                        alt={object.name}
                                    />
                                    <div className="icon-box">
                                        <span className="icon-power"/>
                                    </div>
                                </div>

                                <div className="service-details__content-text1">
                                    <p>{object.description}</p>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

// Dummy data for testing
AI_model.defaultProps = {
    title: "AI Model",
    modelData: {
        name: "Sample AI Model",
        description:
            "This is a detailed description of the AI model, including its purpose and functionality.",
        model_type: "Language Model",
        version: "1.0.0",
        framework: "TensorFlow",
        parameters: 1_500_000_000,
        thumbnail: null,
        applications: ["Chatbots", "Text Summarization", "Language Translation"],
        accuracy: 95.2,
        latency: 50,
        throughput: 1000,
    },
};

export default AI_model;
